var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousarrowdisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.466,
    height: 14.81,
    viewBox: "0 0 9.466 14.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Previous_arrow_disabled",
    "data-name": "Previous arrow disabled",
    transform: "translate(0 14.81) rotate(-90)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M14.809,9.466,7.3,2.941,0,9.466V6.749L7.276,0,14.81,6.736Z",
    fill: "#d3d3d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousarrowdisabled);
export default __webpack_public_path__ + "static/media/Previous arrow disabled.18e2f6f81e90f71dd0517e493d87d03e.svg";
export { ForwardRef as ReactComponent };